// extracted by mini-css-extract-plugin
export default {"symbol":"daodao-brand-footer-pickers-CurrencyPreviewContents__symbol--3D11X"};